export const dateFormat = (d: string) => {
  const month: any = {
    0: "Jan",
    1: "Feb",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "Aug",
    8: "Sept",
    9: "Oct",
    10: "Nov",
    11: "Dec",
  };

  let fd: Date | null = null;

  if (d) {
    fd = new Date(d);
  }

  if (fd && !isNaN(fd.getTime())) {
    const str = `${month[fd.getMonth()]} ${fd.getDate()}, ${fd.getFullYear()}`;
    return str;
  } else {
    return null;
  }
};
